import { render } from "./StatItem.vue?vue&type=template&id=7af3fd02&ts=true"
import script from "./StatItem.vue?vue&type=script&lang=ts"
export * from "./StatItem.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./StatItem.vue?vue&type=style&index=0&id=7af3fd02&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__